module.exports = __webpack_public_path__ + "static/media/ExpEduOp.0f0e9be0.png";